interface AppEnv {
  firebase: {
    apiKey: string;
    projectId: string;
    appId: string;
    authDomain: string;
    storageBucket: string;
  };
  functionsRegion: string;
  stripePublishableKey: string;
  appDeepLink: string;
}

function need(key: string): string {
  const v = import.meta.env[key];
  if (typeof v !== "string" || v.length === 0) {
    throw new Error(`Missing env var: ${key} — copy web/.env.example to .env.local and fill it in`);
  }
  return v;
}

export const env: AppEnv = {
  firebase: {
    apiKey: need("VITE_FIREBASE_API_KEY"),
    projectId: need("VITE_FIREBASE_PROJECT_ID"),
    appId: need("VITE_FIREBASE_APP_ID"),
    authDomain: need("VITE_FIREBASE_AUTH_DOMAIN"),
    storageBucket: need("VITE_FIREBASE_STORAGE_BUCKET"),
  },
  functionsRegion: import.meta.env.VITE_FUNCTIONS_REGION || "us-central1",
  stripePublishableKey: need("VITE_STRIPE_PUBLISHABLE_KEY"),
  appDeepLink: import.meta.env.VITE_APP_DEEP_LINK || "ams://home",
};
